class Domain {

  constructor(url) { this.url = url.toLowerCase(); }
  
  extensions = ['com.br','net.br','abc.br','adm.br','adv.br','agr.br','aju.br','am.br','arq.br','art.br','ato.br','bhz.br','bsb.br','def.br','dev.br','ecn.br','eco.br','edu.br','emp.br','enf.br','eng.br','esp.br','etc.br','eti.br','far.br','feira.br','fm.br','fnd.br','gov.br','gru.br','imb.br','ind.br','inf.br','jus.br','leg.br','log.br','mat.br','med.br','mil.br','mp.br','mus.br','nom.br','ong.br','org.br','poa.br','ppg.br','pro.br','psc.br','psi.br','pvh.br','qsl.br','radio.br','rec.br','rep.br','rio.br','sampa.br','seg.br','srv.br','taxi.br','tc.br','tec.br','teo.br','the.br','tmp.br','trd.br','tur.br','tv.br','udi.br','vet.br','vix.br','vlog.br','wiki.br','zlg.br','com.vc'];
  TLDs = ['br','us','vc','com','net','info','co','org','in','io','temp','tv','top','beauty','bio','io','black','blackfriday','blog','book','buy','buzz','cafe','ceo','click','cloud','club','coach','coffee','college','company','computer','cooking','cool','country','coupon','credit','dance','digital','direct','directory','drive','education','email','engineer','exchange','expert','fail','family','fan','fans','farm','fashion','fast','free','games','gay','gift','gifts','global','guru','help','hosting','inc','industries','joy','lgbt','life','link','live','love','ltda','market','marketing','media','moda','ninja','now','one','online','page','party','pay','phone','photo','ping','pink','pizza','place','play','plus','porn','prime','racing','radio','red','rich','rio','rocks','run','safe','sale','save','science','search','sex','sexy','shoes','shop','shopping','site','smart','smile','social','software','spot','storage','store','studio','style','supplies','supply','surf','systems','tattoo','tax','taxi','team','tech','technology','tennis','tienda','tires','today','tools','top','toys','travel','travelers','trust','university','uno','uol','vet','vip','vote','watch','watches','website','wiki','wine','work','works','world','wow','wtf','xyz','xxx','you','zip','zone'];

  parts(){
    const domainParts = {
      protocol: this.protocol(),
      subdomain: this.subdomain(),
      base: this.base(),
      extension: this.extension()
    }

    return domainParts;
  } 

  protocol(){
    let prot = this.url;
    prot = prot.split('://');

    if (prot.length > 1){
      prot = prot[0];
    } else prot = "";

    return prot;
  }

  subdomain(){
    let subdomain = this.url;
    const base = this.base();
    subdomain = subdomain.replace(this.protocol()+'://','');
    subdomain = subdomain.replace('.'+this.extension(),'');
    
    if (subdomain == base)
      subdomain = ""
    else
      subdomain = subdomain.replace('.'+base,'');    
    
      return subdomain;
  }

  base(){
    let base = this.url;
    base = base.replace(this.protocol()+'://','');
    base = base.replace('.'+this.extension(),'');
    base = base.split('.');
    
    if (base.length > 1)
      base = base[base.length - 1];
    else base = base[0];

    return base;
  }

  extension(){
    let ext;

    this.extensions.forEach((item) => {
      if (this.url.endsWith(item)) 
        ext = item;
    });

    if (!ext){
      this.TLDs.forEach((item) => {
        if (this.url.endsWith(item)) 
          ext = item;
      });
    }

    return ext;
  }

}

export default Domain;